import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kgyttmtun: FaireProductEntity = {
  token: "p_4kgyttmtun",
  type: "product",
  name: "Purely Matcha - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/3a24f8574f38bf3f8082c0a81e2d5b857f430916739af4c1893a3ec10b412395.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7f9431748834ea37d98db6183846a8d9821375dc6d376b05a8a9b7cbda8bd78.jpeg",
    "https://cdn.faire.com/fastly/200c9915f551b4700f540aa0368a44470a278b560b782e72762d921420a72c52.png",
    "https://cdn.faire.com/fastly/6b2d01e918d5c1605a266d91cd944543a927f545091e054abd52e488d63de710.png"
  ],
  priceDollars: 14.3,
  description: "ORGANIC CEREMONIAL GRADE MATCHA\n\nSimply the best, organic, ceremonial grade matcha from Kyushu Island, Japan. \n\nSip for an energy, mood and vibe boost. Feel the bliss from your head to your toes.\n\n100% ORGANIC - SPRING HARVEST - RAW - CEREMONIAL GRADE\n\nHow to Enjoy:\n\n * Whisk 1/2 to 1 tsp matcha powder with 1 tbsp hot (not boiling) water until tiny bubbles form. Top with 1 cup of hot or cold milk for a matcha latte. Sweeten to taste if desired.\n\n * Add to smoothies and baked goods!\n\nWhen to Enjoy:\n\n * As a substitute for your morning coffee \n * As a smooth, mid-day pick-me-up \n * When you need to boost your mood \nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:37.498Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
